export default "__VITE_ASSET__CCDTpe43__"